/**
 * The date printed on a sticker, "22 SEP 26": day, the US English short month in capitals, and a
 * two-digit year, read in the time zone of the site that will receive the boxes.
 *
 * One function for the printer (`apps/api` labels) and the on-screen preview (`StickerPreview`),
 * so the two cannot drift. They did once: the printer formatted with `en-GB`, whose short month for
 * September is "Sept", and every physical sticker read "22 SEPT 26" under a preview saying "SEP".
 * The parts are assembled here rather than taken from `toLocaleDateString`, whose order and
 * punctuation differ by locale ("Sep 22, 26" in `en-US`).
 */
export function stickerDate(d: Date, timeZone?: string): string {
  const parts = new Intl.DateTimeFormat('en-US', { day: '2-digit', month: 'short', year: '2-digit', timeZone }).formatToParts(d);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  return `${part('day')} ${part('month').toUpperCase()} ${part('year')}`;
}

/**
 * How many stickers to print for a SKU at a site the import planned `planned` boxes for: the plan
 * plus 10% spare, rounded up (runbook step 13). Whole-number arithmetic on purpose: `100 * 1.1` is
 * 110.00000000000001 in floating point, and rounding that up prints 111.
 */
export function plannedWithSpare(planned: number): number {
  return Math.ceil((planned * 11) / 10);
}
